// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__n0YT9","colBig":"styles_colBig__2RpNa","colSmall":"styles_colSmall__32Bzl"};